import { EpisodeState } from './types'

const state = (): EpisodeState => ({
  activeEpisode: null,
})

export default state
